<template>
    <div class="edit-category-form">
        <form @submit.prevent="saveCategory" class="edit-category-form-container">
            <h2>{{ $t('Редактирование категории') }}</h2>

            <div class="category-name-input-group">
                <input type="text" class="form-control cagegory-icon" v-model="editCategory.icon" placeholder="👻">
                <input type="text" :class="{'form-control category-name': true, 'is-invalid': hasError('title')}" v-model="editCategory.title" :placeholder="$t('Введите название категории')">
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('title')">{{ getError('title') }}</span>

            <div class="category-controls">
                <div class="checkbox-group mr-32">
                    <input id="edit-expenses-check" v-model="editCategory.expenses" type="checkbox">
                    <label for="edit-expenses-check" class="checkbox-label">
                        {{ $t('расходы') }}
                    </label>
                </div>
                <div class="checkbox-group">
                    <input id="edit-incomes-check" v-model="editCategory.incomes" type="checkbox">
                    <label for="edit-incomes-check" class="checkbox-label">
                        {{ $t('доходы') }}
                    </label>
                </div>
            </div>

            <div class="btn-group">
                <button type="submit" class="btn btn-light">{{ $t('Delete') }}</button>

                <button type="submit" class="btn btn-blue">{{ $t('Save') }}</button>
            </div>
        </form>
        <div class="info-tip" v-if="isSideForm !== true">
            <p>{{ $t('category_desc') }}</p>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { EventBus } from '../../../event-bus';

export default {
    name: "EditCategoryForm",

    props: ['isSideForm', 'category'],

	data: function() {
        return {
            editCategory: {
                title: null,
                icon: null,
                expenses: true,
                incomes: true,
            },

            errors: {},
        };
    },

    mounted() {
        this.editCategory = this.category;
    },

    watch: {
        'editCategory.title': function() {
            delete this.errors['title'];
        },
    },

    methods: {
        ...mapActions(['loadCategories']),

        deleteCategory() {
            axios.delete(`/categories/${this.category.id}`).then(({data}) => {
                    if(data.status == "success") {
                        this.loadCategories();

                        this.$ga.event('deleteCategoryButton', 'click', 'deleted');

                        EventBus.$emit('close-side-form');
                    }
                }).catch(({response}) => {
                    console.log(response);

                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        saveCategory() {
            axios.patch(`/categories/${this.category.id}`, this.editCategory).then(({data}) => {
                    if(data.status == "success") {
                        this.loadCategories();

                        EventBus.$emit('close-side-form');
                    }
                }).catch(({response}) => {
                    console.log(response);

                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },
        
        getError(name) {
            if(this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },
    }
}
</script>

<style scoped lang="scss">
.edit-category-form {
    .edit-category-form-container {
        background: #fff;
        width: calc(100% - 64px);
        border-radius: 5px;
        margin-bottom: 24px;
        padding: 24px 32px;

        @media (max-width: 768px) {
            background: transparent;
            padding: 0 24px;
            width: calc(100% - 48px);
            display: flex;
            flex-direction: column;
            height: 100%;

            .btn-form {
                margin-top: auto;
                margin-bottom: 24px;
            }
        }

        h2 {
            color: #152640;
            font-family: "Proxima Nova Lt";
            font-weight: 600;
            font-size: 18px;
            margin: 0;
            margin-bottom: 24px;
        }

        .category-name-input-group {
            display: flex;
            align-items: center;

            .cagegory-icon {
                width: 24px;
                margin-right: 8px;
            }

            .category-name {
                width: 100%;
            }
        }
            
        .category-controls {
            display: flex;
            align-items: center;
            flex-direction: row;
            margin: 24px 0 32px;
        }

        .btn-group {
            margin-top: auto;
            margin-bottom: 24px;
        }
    }

    .info-tip {
        font-size: 12px;
        font-family: 'Proxima Nova Rg';
        color: rgba(#152640, .5);
    }
}
</style>